// Debounced value. Mirrors the CRM's shared hook
// (crm/apps/web/src/shared/hooks/useDebouncedValue.ts): returns `value` only
// after it has stayed unchanged for `delayMs`. Used by the CRM tabs to keep
// text/filter inputs snappy while debouncing the refetch they trigger.

import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
